var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"7.0.0"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

// This file configures the initialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import * as Sentry from '@sentry/nextjs'
import { COMMON_SENTRY_CONFIG } from './sentryUtils'

Sentry.init({
  ...COMMON_SENTRY_CONFIG,
  integrations: [new Sentry.Replay({
    maskAllText: false,
    networkDetailAllowUrls: [
      process.env.NEXT_PUBLIC_API_BASE_URL ?? '',
      process.env.NEXT_PUBLIC_BASE_URL ?? ''
    ]
  })],
  replaysOnErrorSampleRate: 1.0,
  replaysSessionSampleRate: 1.0
})
